module.exports = __webpack_public_path__ + "img/ruler-pink.e3239ff1.svg";